<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row class="row" v-if="!loading">
            <b-col cols="12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="localAcreditacion.nombre" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Medio" type="text" name="medio" id="medio" rules="" v-model="localAcreditacion.medio" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Función" type="text" name="funcion" id="funcion" rules="max:20" v-model="localAcreditacion.funcion" />
            </b-col>
            <b-col cols="12">
                <DocumentoTipo
                    v-model="localAcreditacion.tipoDocumento"
                    :index="0"
                />
            </b-col>
            <b-col cols="12">
                <DocumentoValor
                    v-model="localAcreditacion.dni"
                    :type="localAcreditacion.tipoDocumento"
                    :index="0"
                />
            </b-col>
            <b-col cols="12">
                <FormInput label="Email" type="text" name="email" id="email" rules="email" v-model="localAcreditacion.email" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Telefono" type="text" name="telefono" id="telefono" rules="numeric" v-model="localAcreditacion.telefono" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Staff, prensa, servicios, etc" type="text" name="servicios" id="servicios" rules="" v-model="localAcreditacion.servicios" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Jornada" type="text" name="jornada" id="jornada" rules="" v-model="localAcreditacion.jornada" />
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Acceso a zonas</label>
                <ValidationProvider name="acceso_zonas" rules="" v-slot="{ errors }">
                    <CkEditorComponent v-model="localAcreditacion.acceso_zonas"/>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Observaciones</label>
                <ValidationProvider name="observaciones" rules="" v-slot="{ errors }">
                    <CkEditorComponent v-model="localAcreditacion.observaciones"/>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" v-if="activacion" class="mb-3">
                <label for="nombre">Mensaje (Texto que le llegara al correo del solicitante)</label>
                <ValidationProvider name="observaciones" rules="" v-slot="{ errors }">
                    <CkEditorComponent v-model="localAcreditacion.mensaje"/>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <label for="nombre">Condiciones</label>
                <ValidationProvider name="condiciones" rules="" v-slot="{ errors }">
                    <CkEditorComponent v-model="localAcreditacion.condiciones"/>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="all-access" data-cy="all-access" v-model="all_access"/>
                    <label for="all-access" class="custom-control-label">All access</label>
                </div>
            </b-col>
            <b-col v-if="puertas && !all_access" cols="12" class="mb-3">
                <label>Puertas</label>
                <ValidationProvider name="puertas" id="puertas" rules="required" v-slot="{ errors }">
                    <multiselect
                        role="button"
                        v-model="localAcreditacion.puertasSelect"
                        id="puertas-select"
                        placeholder="Puertas"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :max-height="150"
                        :multiple="true"
                        label="nombre"
                        track-by="id"
                        :options="puertas"
                    />
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="mt-3 d-flex justify-content-between align-items-center">
                <Button type="submit" name="button" :disabled="loading || terminado">{{activacion ? 'Activar'  : 'GUARDAR'}}</Button>
            </b-col>
        </b-row>
        <LoaderComponent v-else/>
    </ValidationObserver>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';

    export default {
        props: ['evento_id', 'acreditacion', 'activacion'],
        data() {
            return {
                loading: false,
                terminado: false,
                puertas: null,
                conf: {},
                localAcreditacion: { tipoDocumento: 'DNI', ...this.acreditacion },
                all_access: false,
                texto_condiciones: `
                <p>La presente acreditación sólo habilita al titular a acceder, transitar, ocupar y trabajar en las zonas dentro del recinto que se indique en la acreditación y a hacer uso de ella para el fin que se le ha otorgado. Las acreditaciones son personales e intransferibles.</p>

                <p>La acredicación es propiedad de ${this.$store.getters.getTeatro.nombre.toUpperCase()}, que se reserva el derecho de su anulación o retirada bajo sus propios criterios. El uso indebido de la misma supondrá su retirada y la imposibilidad del titular de participar en otros eventos.</p>

                ${this.$store.getters.getTeatro.hash !== 'QyK2Lux6tM7vnfKINhef' ? `<p>El titular no podrá grabar, reproducir o comunicar públicamente sonidos, imágenes, vídeos, datos y/o estadísticas de los eventos que sucedan en el recinto para los que la acreditación da acceso, salvo autorización de la empresa promotora.</p>` : ''}

                <p>Sus datos personales serán tratados a los efectos exclusivos de identificación y control de acceso al recinto.</p>
            `
            }
        },
        methods: {
            getPuertasEvento() {
                this.loading = true;

                let params = {
                    filters: {},
                    evento_id: this.evento_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.puertas-evento'), params).then(res => {
                    this.puertas = res.data.data;
                    if (this.puertas.length == this.localAcreditacion.puertasSelect?.length) {
                        this.all_access = true;
                    }
                }).finally(() => this.loading = false);
            },
            getEvento() {
                this.loading = true;

                let params = {
                    filters: {},
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), params).then(res => {
                    this.localAcreditacion.condiciones = res.data.data.condiciones_acreditaciones ?? this.texto_condiciones;
                })
                    .catch(error => {
                        console.error('Error al cargar el evento', error)
                    })
                    .finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminado = true;
                    this.localAcreditacion.all_access = this.all_access;
                    this.$emit('terminado', this.localAcreditacion);
                }
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getEvento();
            this.getPuertasEvento();

            if(!this.localAcreditacion.condiciones) {
                this.localAcreditacion.condiciones = this.texto_condiciones;
            }

            if (this.teatro.hash === 'QyK2Lux6tM7vnfKINhef' && !this.localAcreditacion.observaciones) {
                this.localAcreditacion.observaciones = `<p>La acreditación deberá ser devuelta a la finalización del partido en la Sala de Prensa del Estadio Salto del Caballo.</p>`;
            }
        },
        components: {
            CkEditorComponent, DocumentoTipo, DocumentoValor
        }
    }
</script>
